export class KeoCardDescriptionProvider {
    static getDescription(keoCard) {
      return `[${keoCard.year}] ${keoCard.cardNumber} - ${keoCard.wasteCode}`;
    }
}